<template>
  <div class="input-util">
    <el-input :size="size" v-model="form[k]"
    :style="`width:${width}`"
    :type="inputType"
    @focus="changeState(true)"
    @blur="changeState(false)"
    :disabled="able ? false : true"
    placeholder="请输入">
      <template v-if="append" slot="append">{{append}}</template>
    </el-input>
  </div>
</template>
<script>
export default {
  props: {
    size: {
      type:String,
      default: 'mini'
    },
    form: {
      type: Object,
      required: true,
      default:() => {}
    },
    k: {
      type: String,
      required: true
    },
    // state: {
    //   type: Object,
    //   required: true
    // },
    width: {
      type: String,
      default: '180px'
    },
    inputType:{
      type:String,
      default:'text'
    },
    index: {
      type: Number
    },
    able: {
      type:Boolean,
      default: true
    },
    append: {
      type: String,
      default: ''
    }
  },
  methods: {
    changeState(res) {
      this.$emit('stateCB',this.k, res , {
        index: this.index,
        form: this.form
      })
    }
  }
}
</script>
<style lang="scss">
.input-util {
  .el-input.is-disabled .el-input__inner {
    background: #fff;
    color: #606266 !important;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Util/InputUtil.vue